import { render, staticRenderFns } from "./MainBreadcrumbs.vue?vue&type=template&id=3c35bd0e&scoped=true&"
import script from "./MainBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./MainBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./MainBreadcrumbs.vue?vue&type=style&index=0&id=3c35bd0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c35bd0e",
  null
  
)

export default component.exports